//* 组件库
import { $loading, $message } from "various-ui";

export const useUserStore = defineStore("user", {
    state: () => {
        return {
            id: "", //* 用户唯一id
            name: "", //* 用户名
            phone: "", //* 用户手机号码
            email: "", //* 用户邮件
            duties: "", //* 用户职务
            avatar: "", //* 用户头像
            introduction: "", //* 用户简介
            organization: "", //* 用户组织
        };
    },
    actions: {
        //* 初始化
        init: async function () {
            //* 插件
            const route = useRoute();
            //* 初始化数据
            const token = useCookie("X-Token");
            //* 校验Token是否有效
            const result = await this.verify(token.value);
            if (result) return this.update(result);
            else {
                //* Token数据清空
                token.value = "";
                //* 用户信息数据清空
                this.update({});
                //* 检测页面是否需要重定向
                if (route.meta.permission) {
                    routerPush({ name: "Home" }, { replace: true });
                }
            }
        },

        //* 用户校验
        verify: async function (token?: null | string) {
            //* Token不存在清空登录状态并检测页面是否需要重定向
            if (!token) return false;
            else {
                try {
                    return await api.frontend("/api/user", { headers: { "X-Token": token }, hidden: true, method: "POST" });
                } catch {
                    return false;
                }
            }
        },

        //* 用户登出
        logout: function () {
            //* 初始化数据
            const token = useCookie("X-Token");
            //* 检测是否存在登录状态
            if (!token.value) return;
            else {
                $loading.open({ message: "" });
                api.frontend("/api/user/logout", {
                    method: "POST",
                    headers: { "X-Token": token.value },
                    finally: () => $loading.close(),
                    success: () => {
                        //* 数据初始化
                        token.value = null;
                        this.update({});
                        //* 页面重新加载
                        window.location.reload();
                    },
                });
            }
        },

        //* 数据更新
        update: function (data: any) {
            this.id = data?.id || "";
            this.name = data?.name || "";
            this.phone = data?.phone || "";
            this.email = data?.email || "";
            this.duties = data?.duties || "";
            this.avatar = data?.avatar || "";
            this.introduction = data?.introduction || "";
            this.organization = data?.organization || "";
        },

        //* 头像上传
        upload: function (data: FormData, callback?: () => void) {
            api.frontend("/api/user/upload", {
                data: data,
                method: "POST",
                headers: { "X-Token": useCookie("X-Token").value || "" },
                finally: () => callback?.(),
                success: (response) => {
                    //* 数据更新
                    this.avatar = response || "";
                },
            });
        },

        //* 信息修改
        change: function (data: any, callback?: () => void) {
            api.frontend("/api/user/update", {
                data: {
                    email: data?.email || this.email,
                    name: data?.name || this.name,
                    phone: data?.phone || this.phone,
                    duties: data?.duties || this.duties,
                    avatar: data?.avatar || this.avatar,
                    introduction: data?.introduction || this.introduction,
                    organization: data?.organization || this.organization,
                },
                method: "POST",
                headers: { "X-Token": useCookie("X-Token").value || "" },
                finally: () => callback?.(),
                success: (response) => {
                    //* 数据更新
                    this.update(response);
                },
            });
        },
    },
});
